import { TypedUseMutationResult, TypedUseQueryStateResult } from '@reduxjs/toolkit/query/react';
import { Alert, Spinner } from 'flowbite-react';
import { PropsWithChildren, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { HiInformationCircle } from 'react-icons/hi';

interface QueryResultProps extends PropsWithChildren {
    // eslint-disable-next-line
    query: TypedUseQueryStateResult<unknown, unknown, any, any>,
    message: string
}

export function QueryResult(
    {query, message, children} : QueryResultProps

) {
    const { t } = useTranslation("shared")

    return (
        <>
            {
                query.error !== undefined ?
                <Alert color="failure" icon={HiInformationCircle}>
                    <span className="font-medium">{message}</span> {t("retry")}
                </Alert>
                : null
            }

            {
                query.isLoading ?
                <Spinner aria-label={t("loading")}/>
                : null
            }
            {
                query.isSuccess ?
                    <Suspense>
                        {children}
                    </Suspense>
                    : null
            }
        </>
    )
}


export type ErrorMapper = (status: number, message: string | undefined) => string | null

export interface ErrorProps {
    // eslint-disable-next-line
    api: TypedUseMutationResult<unknown, unknown, any>,
    failMessage: string,
    errorMapper?: ErrorMapper
}

export function Error({api, failMessage, errorMapper,}: ErrorProps) {
    const {t} = useTranslation('shared');

    function getFailMessage() {
        if (errorMapper !== undefined && api.isError && api.error['status'] !== undefined) {
            return errorMapper(api.error['status'] as number, api.error['message']) ?? failMessage;
        } else if (api.isError && api.error['status'] !== undefined) {
            return `${failMessage} ${api.error['status']}  : ${api.error['message']}`;
        } else {
            return failMessage;
        }
    }

    return (
        <span>
            <span className="font-medium">{getFailMessage()}</span> {t('retry')}
        </span>
    );
}